import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    requestOtp: boolean
}

interface Variables {
    email: string,
}

export const REQUEST_OTP: TypedDocumentNode<Result, Variables> = gql`
    query RequestOtp($email: String!) {
        requestOtp(email: $email)
    }       
`
